import styled from '@emotion/styled';

import {
	mypageFieldBoxCss,
	mypageFormContainerCss,
	mypageSubPageTitleCss,
} from '@/components/MyPage/shared/subPageStyles';

export const FormContainer = styled.form`
	display: flex;
	flex-direction: column;
	gap: 4.8rem;
	max-width: 44rem;
	width: 100%;
	margin: 0 auto;
	${mypageFormContainerCss}
`;
export const Title = styled.h2`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: ${(props) => props.theme.ui.lineHeight.heading};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	${mypageSubPageTitleCss}
`;
export const FieldBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	${mypageFieldBoxCss}
`;
export const PasswordInput = styled.input`
	height: 4.4rem;
	padding: 0 1.2rem;
	border: 1px solid #adb5bd;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: #212121;
	width: 100%;
	&:focus {
		outline-color: ${(props) => props.theme.colors.primary400};
	}
	&::placeholder {
		color: #adb5bd;
	}
	&:read-only {
		background-color: #e9ecef;
		border: 1px solid #adb5bd;
	}
`;
export { NextButton, FindButton } from '@/components/common/Button/style';
export const FlexRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.4rem;
	width: 100%;
	height: 4.4rem;
	div {
		flex: 1;
		height: 100%;
	}
	input {
		flex: 1;
		height: 100%;
	}
`;
export const GenderBox = styled.div`
	display: flex;
	gap: 4rem;
`;
export const GenderRadio = styled.div`
	display: flex;
	gap: 0.4rem;
`;
export const AddressInput = styled.input`
	width: 100%;
	&:read-only {
		background-color: #e9ecef;
		border: 1px solid #adb5bd;
	}
`;
export const AddressBox = styled.div`
	display: flex;
	gap: 0.4rem;
	height: 4.4rem;
`;
export const AddressContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
`;
export const TabBox = styled.div`
	display: flex;
	width: 100%;
	height: 4.4rem;
	background-color: #fff;
	color: #868e96;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	.tab {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
		height: 100%;
		border: 1.4px solid #adb5bd;
		&.active {
			border: 1px solid ${(props) => props.theme.colors.primary400};
			color: ${(props) => props.theme.colors.primary400};
		}
	}
`;
export const Danger = styled.p`
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: ${(props) => props.theme.lineHeight.tight};
	letter-spacing: ${(props) => props.theme.ui.letterSpacing.caption};
	color: ${(props) => props.theme.colors.red600};
`;
